import type { AgentExecutionDto } from '@terra/shared-contracts-agent-execution';
import type { AiDiscoverySummary } from './discovery.utils';
import { hasActiveDiscoveryExecution } from './discovery.utils';

export function resolveIsAiDiscoveryRunning({
  executions,
  discoverySummary,
}: {
  executions: AgentExecutionDto[];
  discoverySummary: AiDiscoverySummary | undefined;
}): boolean {
  const hasActiveExecution =
    hasActiveDiscoveryExecution(executions) ||
    (discoverySummary?.activeExecutionCount ?? 0) > 0;

  return (
    hasActiveExecution ||
    (discoverySummary?.pendingProbeCount ?? 0) > 0 ||
    (discoverySummary?.awaitingCodeDiscovery ?? false) ||
    discoverySummary?.discoveryStatus === 'RUNNING'
  );
}

export function resolveAiDiscoveryLiveCount({
  executions,
  discoverySummary,
  isRunning,
}: {
  executions: AgentExecutionDto[];
  discoverySummary: AiDiscoverySummary | undefined;
  isRunning: boolean;
}): number {
  if (!isRunning) {
    return 0;
  }

  const pending = discoverySummary?.pendingProbeCount ?? 0;
  const activeExecutions = executions.filter(
    (execution) =>
      execution.status === 'RUNNING' || execution.status === 'PENDING',
  ).length;
  const summaryActive = discoverySummary?.activeExecutionCount ?? 0;

  return Math.max(pending, activeExecutions, summaryActive, 1);
}
